import axios from 'axios';

const apiVersion = ''


export default ()=>{
    return axios.create({
        baseURL: process.env.REACT_APP_API_URL + apiVersion
    })
}